/* eslint-disable quotes */
// Käännökset suomeksi ja englanniksi
const translations = {
  fi: {
    // Menu
    myPlayers: 'Pelaajani',
    allPlayers: 'Kaikki pelaajat',
    lists: 'Listat',
    training: 'Harjoittelu',
    transfers: 'Siirrot',
    simulator: 'Simu',
    teamSpirit: 'Joukkuehenki',
    skills: 'Taidot',
    achievements: 'Saavutukset',
    myPage: 'Minun sivu',
    login: 'Login',
    loggedIn: 'Kirjautunut sisään',

    // Login page
    logout: 'Logout',
    manualUpdate: 'Pelaajien manuaalinen päivitys',
    layoutNormalOption: 'Normaalileveys',
    layoutWideOption: 'Leveä',
    layoutFullOption: 'Koko ruutu',
    nationalTeam: 'Maajoukkue',
    selectCountry: 'Valitse maa',
    myTeams: 'Minun sivuni',
    adminTools: 'Admin-työkalut',
    updateAllPlayers: 'Päivitä kaikki pelaajat',
    refreshMissingTeams: 'Päivitä puuttuvat joukkueet',
    syncNationData: 'Synkronoi maatiedot',
    userManagement: 'Käyttäjien hallinta',
    searchUser: 'Hae käyttäjää',
    selected: 'Valittu',
    currentRoles: 'Nykyiset roolit',
    selectRole: 'Valitse rooli',
    grantRole: 'Myönnä rooli',
    staff: 'Staff',
    refresh: 'Päivitä',
    user: 'Käyttäjä',
    role: 'Rooli',
    action: 'Toiminto',
    remove: 'Poista',
    noStaffMembers: 'Ei Staff-jäseniä',

    // Messages
    updateInProgress: 'Päivitys käynnissä',
    updateSuccess: 'Päivitys onnistui',
    updateFailed: 'Päivitys epäonnistui',
    countryChanged: 'Aktiivinen maa vaihdettu',
    countryChangeFailed: 'Maan vaihto epäonnistui',
    teamVisibilityUpdated: 'Joukkueen näkyvyys päivitetty',
    teamVisibilityFailed: 'Joukkueen näkyvyyden päivitys epäonnistui',
    hideTrainingData: 'Piilota harjoitustiedot',
    teamVisibilityInfo:
      'Pelaajiesi tiedot näkyvät "Julkinen" asennossa vain maajoukkueen seuraajille. Jos haluat piilottaa tiedot myös scouteilta, vaihda joukkueen valinnaksi "Piilotettu". “Piilota harjoitustiedot” piilottaa harjoitustiedot kaikilta, myös omistajalta. Huomioi, että päävalmentaja näkee aina pelaajien taidot, mutta ei harjoitustietoja, mikäli ne on piilotettu. Jos treenaat maajoukkueelle, älä piilota tietoja!',
    refreshTeams: 'Päivitä joukkueet',
    teamsRefreshing: 'Päivitetään joukkueita...',
    teamsRefreshSuccess: 'Joukkueet päivitetty',
    teamsRefreshFailed: 'Joukkueiden päivitys epäonnistui',
    roleGranted: 'Rooli myönnetty käyttäjälle',
    roleGrantFailed: 'Roolin myöntö epäonnistui',
    roleRemoved: 'Rooli poistettu',
    roleRemoveFailed: 'Roolin poisto epäonnistui',
    selectUserRoleCountry: 'Valitse käyttäjä, rooli ja maajoukkue',
    confirmRemoveRole: 'Haluatko varmasti poistaa roolin?',
    nationSyncSuccess: 'Maatiedot synkronoitu',
    nationSyncFailed: 'Maatietojen synkronointi epäonnistui',
    allPlayersUpdateSuccess: 'Kaikkien pelaajien päivitys valmis',
    allPlayersUpdateFailed: 'Kaikkien pelaajien päivitys epäonnistui',
    missingTeamsRefreshSuccess: 'Puuttuvat joukkueet päivitetty',
    missingTeamsRefreshFailed: 'Puuttuvien joukkueiden päivitys epäonnistui',
    hanniUpdateFailed: 'Hannin päivitys epäonnistui',
    logoutAllFailed: 'Kirjautumistietojen päivitys epäonnistui',

    // Info text
    welcomeTitle: 'Suomen U21/NT Tracker',
    welcomeText:
      'Paina Login kirjautuaksesi sisään ja lisätäksesi pelaajasi tietokantaan maajoukkueen seuraajien nähtäväksi. Kirjautumisen jälkeen voit valita, minkä joukkueiden pelaajat ovat seuraajien näkyvissä.',
    infoText:
      'Jos kirjauduit sisään ensimmäisen kerran, pelaajasi pitäisi olla päivitetty automaattisesti. Mikäli olet ostanut tai nostanut pelaajan, jota ei löydy Minun pelaajista, voit päivittää pelaajalistan Pelaajien manuaalinen päivitys -napista. HUOM! Jos pelaajat eivät lataudu Pelaajani -sivulle, kirjaudu ulos ja takaisin sisään.',

    refreshLoginInfoText: 'Mikäli pelaajien päivitys ei toimi, kokeile',
    refreshLoginCredentials: 'päivittää kirjautumistiedot',

    // Team visibility
    public: 'Julkinen',
    private: 'Piilotettu',

    // Player page
    age: 'Ikä',
    yearsAnd: 'vuotta ja',
    days: 'päivää',
    nextBirthday: 'seuraava syntymäpäivä',
    character: 'Luonne',
    experience: 'Kokemus',
    leadership: 'Johtajuus',
    loyalty: 'Uskollisuus',
    owner: 'Omistaja',
    since: 'alkaen',
    salary: 'Palkka',
    specialty: 'Erikoisuus',
    form: 'Kunto',
    estimatedForm: 'Laskennallinen kunto',
    stamina: 'Kestävyys',
    lastUpdated: 'Viimeisin päivitys',
    trainingInfo: 'Harjoittelutiedot',
    trainingPlan: 'Harjoittelusuunnitelma',
    skill: 'Taito',
    weeks: 'Viikot',
    skillLevel: 'Taitotaso',
    noAccessToPlayer: 'Ei oikeutta pelaajan sivuille',

    // Lists page
    candidateLists: 'Ehdokaslistat',
    requirementLists: 'Vaatimuslistat',
    name: 'Nimi',
    country: 'Maa',
    players: 'Pelaajia',
    requirements: 'Vaatimukset',
    noCandidateLists:
      'Ei ehdokaslistoja. Luo uusi lista painamalla "Luo uusi lista".',
    noRequirementLists:
      'Ei vaatimuslistoja. Luo uusi lista painamalla "Luo uusi lista".',
    loadingLists: 'Ladataan listoja...',
    manageMode: 'Hallinnoi listoja',
    stopManaging: 'Lopeta hallinta',
    createNewList: '+ Luo uusi lista',
    confirmDeleteCandidate: 'Haluatko varmasti poistaa tämän ehdokaslistan?',
    confirmDeleteList: 'Haluatko varmasti poistaa tämän vaatimuslistan?',
    mergeLists: 'Yhdistä listoja',
    accessDenied: 'Ei käyttöoikeutta',
    staffOnlyPage:
      'Tämä sivu on tarkoitettu vain maajoukkueen Staff-jäsenille.',
    returnToHome: 'Palaa etusivulle',

    // Scout skills
    playerSkillsUpdated: 'Pelaajan taidot päivitetty',
    skillUpdateHistory: 'Taitopäivitysten historia',
    hideSkillUpdateHistory: 'Piilota taitopäivitysten historia',
    updatedAt: 'Päivitetty',
    updatedBy: 'Päivittäjä',
    skillChanges: 'Muutokset',
    playerAddedToList: 'Pelaaja lisätty listalle!',
    addingFailed: 'Lisääminen epäonnistui',
    trainingPlanDeleted: 'Harjoittelusuunnitelma poistettu onnistuneesti!',
    trainingPlanDeleteFailed:
      'Harjoittelusuunnitelman poistaminen epäonnistui.',
    trainingPlanSent: 'Harjoittelusuunnitelma lähetetty onnistuneesti!',
    trainingPlanSendFailed: 'Harjoittelusuunnitelman lähettäminen epäonnistui.',
    playerBelongsToLists: 'Pelaaja kuuluu seuraaviin listoihin:',
    playerNotInAnyList: 'Pelaaja ei kuulu mihinkään listaan.',
    updateSkills: 'Päivitä taidot',
    addToList: 'Lisää listalle',
    selectList: 'Valitse lista',
    addTargetSkill: 'Lisää tavoitetaito',
    targetLevel: 'Tavoitetaso',
    calculatePlan: 'Laske suunnitelma',
    deletePlan: 'Poista suunnitelma',
    targetSkillsEntry: 'Tavoitetaitojen lisäys',
    selectSkill: 'Valitse taito',
    // SkillDistribution page
    skillDistribution: 'Taitojen jakautuminen',
    searchFailed: 'Haku epäonnistui',
    searchCompleted: 'Haku valmis',
    noValidPlayerIds: 'Ei kelvollisia pelaaja-ID:itä löytynyt',
    playersAdded: 'pelaajaa lisätty',
    playersFailed: 'epäonnistui',
    noPlayersFound: 'Pelaajia ei löytynyt',
    userNotRecognized: 'Käyttäjää ei tunnistettu',
    saveFailed: 'Tallennus epäonnistui',
    loadFailed: 'Tallennuksen lataus epäonnistui',
    settingsSaved: 'Asetukset tallennettu',
    defaultValuesRestored: 'Vakioarvot palautettu',
    skillsMayExceed: 'Taidot voivat ylittyä, jos distribution-arvo niin vaatii',
    minimumSkills: 'Minimitaidot, jonka pelaajan täytyy saavuttaa:',
    add: 'Lisää',
    clear: 'Tyhjennä',
    reset: 'Nollaa',
    save: 'Tallenna',
    loadSave: 'Lataa tallennus',
    noSavedConfiguration: 'Tietokannasta ei löytynyt tallennettuja asetuksia',
    savedConfigurationLoaded: 'Tallennus ladattu',
    skillsMayNotReach:
      'Taidot saattavat jäädä tämän alle, mikäli distribution arvo ei vaadi sitä',
    maximumSkills: 'Maksimitaidot, joita pelaaja ei saa ylittää:',
    locksSkillLevel: 'Tämä lukitsee taitotason, vaikka distribution olisi mitä',
    addPositionToTable: 'Lisää pelipaikka taulukkoon',
    selectPosition: 'Valitse pelipaikka...',
    fetchAll: 'Optimoi taidot',
    showTrainingWeeks: 'Näytä harjoitusviikot',
    hideTrainingWeeks: 'Piilota harjoitusviikot',
    startingSkillsAndAge: 'Lähtötaidot ja ikä',
    searchPlayerById: 'Hae pelaaja ID:llä',
    search: 'Hae',
    playerId: 'Pelaajan ID',
    optimizeSkills: 'Optimoi taidot',
    exportPlan: 'Vie suunnitelma',
    positionForOptimization: 'Pelipaikka optimointiin',
    optimizedSkillsImported: 'Optimoidut taidot tuotu tavoitteiksi',

    // Target levels page
    targetLevels: 'Tavoitetasot',
    targetLevelsTitle: 'Tavoitetasot',
    seniorTeam: 'Aikuisten maajoukkue',
    u21Team: 'U21',
    emPlayers: 'EM-kisapelaajat',
    mmPlayers: 'MM-kisapelaajat',
    seniorPlayers: 'Aikuisten maajoukkuepelaajat',
    playerType: 'Pelaajatyyppi',
    editing: 'Muokkaus',
    saveChanges: 'Tallenna muutokset',
    cancelEdit: 'Peruuta',
    editTargetLevels: 'Muokkaa tavoitetasoja',
    targetLevelsSaved: 'Tavoitetasot tallennettu!',
    targetLevelsSaveFailed: 'Tavoitetasojen tallennus epäonnistui.',
    loadingTargetLevels: 'Ladataan tavoitetasoja...',
    noTargetLevels: 'Tavoitetasoja ei löytynyt.',
    initializeDefaults: 'Alusta oletustavoitetasot',
    targetLevelsInitialized: 'Oletustavoitetasot alustettu!',
    backToLists: 'Takaisin listoihin',
    currentSeason: 'Nykyinen kausi',
    oddSeason: 'Pariton kausi (MM)',
    evenSeason: 'Parillinen kausi (EM)',
    headScoutOnly: 'Vain HeadScout voi muokata tavoitetasoja.',

    // Card headers
    generalInfo: 'Yleistiedot',
    scoutComments: 'Scoutin kommentit',
    enterScoutComments: 'Kirjoita kommentit...',
    commentWrittenBy: 'Kirjoittanut',
    saveComment: 'Tallenna kommentti',
    saving: 'Tallennetaan...',
    commentSavedAt: 'Tallennettu',

    // Training calculator
    trainingCalculator: 'Harjoittelulaskuri',
    calculationInputs: 'Laskennan lähtötiedot',
    sublevelCalculation: 'Alatason laskenta',
    send: 'Lähetä',
    staminaTarget: 'Kestävyyden tavoite',
    trainingSessions: 'Harjoituskerrat',
    playerStaminaLabel: 'Kestävyys laskennassa',
    ageInCalculation: 'Ikä laskennassa',
    sublevelAfter: 'Alataso treenien jälkeen',
    currentSublevel: 'Nykyinen alataso',
    continuePlan: 'Jatka suunnitelmaa',
    andMoreLists: 'muuhun listaan',
    summaryLabel: 'Yhteenveto',
    skillLabel: 'Taito',
    staminaLabel: 'Kestävyys',
    finalAge: 'Loppuikä',
    equilibrium: 'Tasapaino',
    maxStamina: 'Maksimikestävyys',
    usedShare: 'Käytetty %',
    weekShort: 'VK',
    staminaShare: 'Kest. %',
    staminaTrainingShare: 'Kest. osuus',
    trainingAndDrop: 'Treeni/pudotus',
    updateSublevels: 'Päivitä alatasot',
    calculateSublevel: 'Laske alataso',
    sublevelHelp:
      'Katso Hattrickista pelaajan treeniarviosta, montako treeniä pelaajan tarvitsee nostaakseen tasoa. Tämän jälkeen vähennä minuutteja hiekkalaatikosta, kunnes viikkomäärä nousee yhdellä. Aseta minuuteiksi edellinen minuuttimäärä, esim. jos pelaaja tarvitsee 5 harjoitusta 87 minuutilla ja 6 harjoitusta 86 minuutilla, aseta laskuriin 5 kertaa ja 87 minuuttia.',

    // Training history
    trainingHistory: 'Harjoitushistoria',
    trainingMode: 'Harjoitusmuoto',
    trainingCoach: 'Valmentaja',
    trainingAssistants: 'Apuvalm.',
    trainingMinutes: 'Minuutit',
    trainingIntensity: 'Intensiteetti',
    efficiency: 'Teho',
    startLevel: 'Lähtötaso',
    skillChange: 'Taitomuutos',
    seasonWeek: 'Kausi/Viikko',
    date: 'Päivämäärä',
    show: 'Näytä',
    hide: 'Piilota',

    // Simulator
    simulatorGuideTitle: 'Simulaattorin käyttö',
    simulatorGuideInfo: 'Näytä/piilota simulaattorin käyttöohje',
    simulatorGuideLoad:
      'Lataa omat ottelut ja valitse taulukosta ottelu. Simulaattori hakee silloin koti- ja vierasjoukkueen arvosanat sekä kokoonpanot.',
    simulatorGuidePositions:
      'Kestävyys, käyttäytymisnuolet ja erikoisuudet asetetaan pelipaikkakohtaisesti. Vain aktiiviset pelipaikat vaikuttavat simulointiin.',
    simulatorGuideRatings:
      'Voit muokata arvosanoja, taktiikkaa ja pelipaikkoja tai liittää arvosanat suoraan leikepöydältä.',
    simulatorGuideRun:
      'Aja arvio Simulate Match -painikkeella. Tulokset ovat 10 000 simuloidun ottelun keskiarvoja.',
    leagueSimulationLoading: 'Simuloidaan sarjaa…',
    leagueSimulationFailed: 'Sarjasimulaation haku epäonnistui.',
    leagueTable: 'Sarjataulukko',
    team: 'Joukkue',
    goalsFor: 'Tehdyt maalit',
    goalsAgainst: 'Päästetyt maalit',
    goalDifference: 'Maaliero',
    goalDifferenceVsExpected: 'ME-xME',
    matches: 'Ottelut',
    round: 'Kierros',
    home: 'Koti',
    away: 'Vieras',
    result: 'Tulos',
    simulation: 'Simu',
    draw: 'Tasapeli',
    goalsHome: 'maalit koti',
    goalsAway: 'maalit vieras',
    simulateMatch: 'Avaa ottelusimulaattori',
    season: 'Kausi',
    leaguePoints: 'P',
    expectedPointsShort: 'xP',
    goalsForShort: 'TM',
    goalsAgainstShort: 'PM',
    goalDifferenceShort: 'M+/-',
    expectedGoalsForShort: 'xTM',
    expectedGoalsAgainstShort: 'xPM',
    expectedGoalDifferenceShort: 'xM+/-',
    goalDifferenceVsExpectedShort: 'M-xM',
    expectedHomeShort: 'xK',
    expectedDrawShort: 'xT',
    expectedAwayShort: 'xV',
    expectedGoalsHomeShort: 'xTM K',
    expectedGoalsAwayShort: 'xTM V',

    // Team spirit calculator
    teamSpiritCalculator: 'Joukkuehenki ja keskikenttälaskuri',
    teamSpiritCalculatorHelp:
      'Syötä joukkueiden keskikenttäarvot niin voit arvioida seuraavan pelin KK arvoa.\n -täpästä vertailu tehdään seuraaviin peleihin kyseisen pelin kk-arvosta.',
    startingDate: 'Aloituspäivä',
    startingSpirit: 'Aloitusjoukkuehenki',
    matchCount: 'Otteluita',
    attitude: 'Asenne',
    midfield: 'Keskikenttä',
    spiritBefore: 'Joukkuehenki ennen peliä',
    spiritAfter: 'Joukkuehenki pelin jälkeen',
    performanceCoeff: 'Kerroin',
    nextMatchEstimate: 'Ottelun arvio',
    rowType: 'Rivi',
    matchRow: 'Ottelu',
    updateRow: 'Päivitys',
    resetRow: 'Reset',
    showIntermediateDays: 'Näytä välipäivät',
    updatesBetweenMatches: 'Päivityksiä välissä',
    finalMatch: 'Ei seuraavaa ottelua',
    note: 'Huom',
    teamSpiritTimelineNote:
      'Oletusrytmi vuorottelee 3 ja 4 päivityksen välejä otteluiden välillä. Viimeinen päivitys voi olla samalla päivällä kuin seuraava ottelu.',
  },
  en: {
    // Menu
    myPlayers: 'My Players',
    allPlayers: 'All Players',
    lists: 'Lists',
    training: 'Training',
    transfers: 'Transfers',
    simulator: 'Simulator',
    teamSpirit: 'Team Spirit',
    skills: 'Skills',
    achievements: 'Achievements',
    myPage: 'My Page',
    login: 'Login',
    loggedIn: 'Logged in',

    // Login page
    logout: 'Logout',
    manualUpdate: 'Manual player update',
    layoutNormalOption: 'Normal width',
    layoutWideOption: 'Wide',
    layoutFullOption: 'Full screen',
    nationalTeam: 'National Team',
    selectCountry: 'Select country',
    myTeams: 'My page',
    adminTools: 'Admin Tools',
    updateAllPlayers: 'Update all players',
    refreshMissingTeams: 'Refresh missing teams',
    syncNationData: 'Sync nation data',
    userManagement: 'User Management',
    searchUser: 'Search user',
    selected: 'Selected',
    currentRoles: 'Current roles',
    selectRole: 'Select role',
    grantRole: 'Grant role',
    staff: 'Staff',
    refresh: 'Refresh',
    user: 'User',
    role: 'Role',
    action: 'Action',
    remove: 'Remove',
    noStaffMembers: 'No staff members',

    // Messages
    updateInProgress: 'Update in progress',
    updateSuccess: 'Update successful',
    updateFailed: 'Update failed',
    countryChanged: 'Active country changed',
    countryChangeFailed: 'Country change failed',
    teamVisibilityUpdated: 'Team visibility updated',
    teamVisibilityFailed: 'Team visibility update failed',
    hideTrainingData: 'Hide training data',
    teamVisibilityInfo:
      'When set to "Public", your player information is available only to national-team followers. To hide it from scouts as well, set the team to "Private". “Hide training data” hides training data from everyone, including the owner. Note that the Head Scout can always see player skills, but not training data when it is hidden. If you are training players for a national team, do not hide this information!',
    refreshTeams: 'Refresh teams',
    teamsRefreshing: 'Refreshing teams...',
    teamsRefreshSuccess: 'Teams refreshed',
    teamsRefreshFailed: 'Refreshing teams failed',
    roleGranted: 'Role granted to user',
    roleGrantFailed: 'Role grant failed',
    roleRemoved: 'Role removed',
    roleRemoveFailed: 'Role removal failed',
    selectUserRoleCountry: 'Select user, role and national team',
    confirmRemoveRole: 'Are you sure you want to remove the role?',
    nationSyncSuccess: 'Nation data synced',
    nationSyncFailed: 'Nation data sync failed',
    allPlayersUpdateSuccess: 'All players update complete',
    allPlayersUpdateFailed: 'All players update failed',
    missingTeamsRefreshSuccess: 'Missing teams refreshed',
    missingTeamsRefreshFailed: 'Refreshing missing teams failed',
    hanniUpdateFailed: 'Hanni update failed',
    logoutAllFailed: 'Refreshing login credentials failed',

    // Info text
    welcomeTitle: 'Finland U21/NT Tracker',
    welcomeText:
      'Press Login to sign in and add your players to the database for national-team followers to see. After signing in, you can choose which teams\' players are visible to followers.',
    infoText:
      'If you logged in for the first time, your players should be updated automatically. If you have bought or promoted a player that is not found in My Players, you can update the player list using the Manual player update button. NOTE! If players do not load on My Players page, log out and back in.',

    refreshLoginInfoText: 'If player updates do not work, try to',
    refreshLoginCredentials: 'refresh your login credentials',

    // Team visibility
    public: 'Public',
    private: 'Hidden',

    // Player page
    age: 'Age',
    yearsAnd: 'years and',
    days: 'days',
    nextBirthday: 'next birthday',
    character: 'Character',
    experience: 'Experience',
    leadership: 'Leadership',
    loyalty: 'Loyalty',
    owner: 'Owner',
    since: 'since',
    salary: 'Salary',
    specialty: 'Specialty',
    form: 'Form',
    estimatedForm: 'Estimated form',
    stamina: 'Stamina',
    lastUpdated: 'Last updated',
    trainingInfo: 'Training Info',
    trainingPlan: 'Training Plan',
    skill: 'Skill',
    weeks: 'Weeks',
    skillLevel: 'Skill Level',
    noAccessToPlayer: 'No access to player page',

    // Lists page
    candidateLists: 'Candidate Lists',
    requirementLists: 'Requirement Lists',
    name: 'Name',
    country: 'Country',
    players: 'Players',
    requirements: 'Requirements',
    noCandidateLists:
      'No candidate lists. Create a new list by clicking "Create new list".',
    noRequirementLists:
      'No requirement lists. Create a new list by clicking "Create new list".',
    loadingLists: 'Loading lists...',
    manageMode: 'Manage lists',
    stopManaging: 'Stop managing',
    createNewList: '+ Create new list',
    confirmDeleteCandidate:
      'Are you sure you want to delete this candidate list?',
    confirmDeleteList: 'Are you sure you want to delete this requirement list?',
    mergeLists: 'Merge lists',
    accessDenied: 'Access Denied',
    staffOnlyPage: 'This page is only for National Team Staff members.',
    returnToHome: 'Return to Home',

    // Scout skills
    playerSkillsUpdated: 'Player skills updated',
    skillUpdateHistory: 'Skill update history',
    hideSkillUpdateHistory: 'Hide skill update history',
    updatedAt: 'Updated',
    updatedBy: 'Updated by',
    skillChanges: 'Changes',
    playerAddedToList: 'Player added to list!',
    addingFailed: 'Adding failed',
    trainingPlanDeleted: 'Training plan deleted successfully!',
    trainingPlanDeleteFailed: 'Training plan deletion failed.',
    trainingPlanSent: 'Training plan sent successfully!',
    trainingPlanSendFailed: 'Training plan send failed.',
    playerBelongsToLists: 'Player belongs to the following lists:',
    playerNotInAnyList: 'Player is not in any list.',
    updateSkills: 'Update skills',
    addToList: 'Add to list',
    selectList: 'Select list',
    addTargetSkill: 'Add target skill',
    targetLevel: 'Target level',
    calculatePlan: 'Calculate plan',
    deletePlan: 'Delete plan',
    targetSkillsEntry: 'Target skill entry',
    selectSkill: 'Select skill',
    // SkillDistribution page
    skillDistribution: 'Skill Distribution',
    searchFailed: 'Search failed',
    searchCompleted: 'Search completed',
    noValidPlayerIds: 'No valid player IDs found',
    playersAdded: 'players added',
    playersFailed: 'failed',
    noPlayersFound: 'No players found',
    userNotRecognized: 'User not recognized',
    saveFailed: 'Save failed',
    loadFailed: 'Loading saved settings failed',
    settingsSaved: 'Settings saved',
    defaultValuesRestored: 'Default values restored',
    skillsMayExceed: 'Skills may exceed if distribution value requires it',
    minimumSkills: 'Minimum skills the player must achieve:',
    add: 'Add',
    clear: 'Clear',
    reset: 'Reset',
    save: 'Save',
    loadSave: 'Load save',
    noSavedConfiguration: 'No saved settings found in the database',
    savedConfigurationLoaded: 'Saved configuration loaded',
    skillsMayNotReach:
      'Skills may not reach this if distribution value does not require it',
    maximumSkills: 'Maximum skills the player cannot exceed:',
    locksSkillLevel: 'This locks the skill level regardless of distribution',
    addPositionToTable: 'Add position to table',
    selectPosition: 'Select position...',
    fetchAll: 'Optimize skills',
    showTrainingWeeks: 'Show training weeks',
    hideTrainingWeeks: 'Hide training weeks',
    startingSkillsAndAge: 'Starting skills and age',
    searchPlayerById: 'Search player by ID',
    search: 'Search',
    playerId: 'Player ID',
    optimizeSkills: 'Optimize skills',
    exportPlan: 'Export plan',
    positionForOptimization: 'Position for optimization',
    optimizedSkillsImported: 'Optimized skills imported as targets',

    // Target levels page
    targetLevels: 'Target Levels',
    targetLevelsTitle: 'Target Levels',
    seniorTeam: 'Senior National Team',
    u21Team: 'U21',
    emPlayers: 'Euro Championship Players',
    mmPlayers: 'World Championship Players',
    seniorPlayers: 'Senior National Team Players',
    playerType: 'Player Type',
    editing: 'Editing',
    saveChanges: 'Save changes',
    cancelEdit: 'Cancel',
    editTargetLevels: 'Edit target levels',
    targetLevelsSaved: 'Target levels saved!',
    targetLevelsSaveFailed: 'Target levels save failed.',
    loadingTargetLevels: 'Loading target levels...',
    noTargetLevels: 'No target levels found.',
    initializeDefaults: 'Initialize default target levels',
    targetLevelsInitialized: 'Default target levels initialized!',
    backToLists: 'Back to lists',
    currentSeason: 'Current season',
    oddSeason: 'Odd season (WC)',
    evenSeason: 'Even season (EC)',
    headScoutOnly: 'Only HeadScout can edit target levels.',

    // Card headers
    generalInfo: 'General Info',
    scoutComments: 'Scout Comments',
    enterScoutComments: 'Write comments...',
    commentWrittenBy: 'Written by',
    saveComment: 'Save comment',
    saving: 'Saving...',
    commentSavedAt: 'Saved',

    // Training calculator
    trainingCalculator: 'Training Calculator',
    calculationInputs: 'Calculation Inputs',
    sublevelCalculation: 'Sublevel Calculation',
    send: 'Send',
    staminaTarget: 'Stamina Target',
    trainingSessions: 'Sessions',
    playerStaminaLabel: 'Stamina in calculation',
    ageInCalculation: 'Age in calculation',
    sublevelAfter: 'Sublevel after training',
    currentSublevel: 'Current sublevel',
    continuePlan: 'Continue plan',
    andMoreLists: 'more lists',
    summaryLabel: 'Summary',
    skillLabel: 'Skill',
    staminaLabel: 'Stamina',
    finalAge: 'Final Age',
    equilibrium: 'Equilibrium',
    maxStamina: 'Max Stamina',
    usedShare: 'Used %',
    weekShort: 'WK',
    staminaShare: 'Stam. %',
    staminaTrainingShare: 'Stam. share',
    trainingAndDrop: 'Train/drop',
    updateSublevels: 'Update sublevels',
    calculateSublevel: 'Calculate sublevel',
    sublevelHelp:
      "Check the player's training estimate in Hattrick to see how many sessions the player needs to increase a level. Then reduce the minutes in the sandbox until the number of weeks increases by one. Set the minutes to the previous amount, e.g. if the player needs 5 sessions at 87 minutes and 6 sessions at 86 minutes, set the calculator to 5 sessions and 87 minutes.",

    // Training history
    trainingHistory: 'Training History',
    trainingMode: 'Training Mode',
    trainingCoach: 'Coach',
    trainingAssistants: 'Assistants',
    trainingMinutes: 'Minutes',
    trainingIntensity: 'Intensity',
    efficiency: 'Efficiency',
    startLevel: 'Start Level',
    skillChange: 'Skill Change',
    seasonWeek: 'Season/Week',
    date: 'Date',
    show: 'Show',
    hide: 'Hide',

    // Simulator
    simulatorGuideTitle: 'Using the simulator',
    simulatorGuideInfo: 'Show or hide simulator instructions',
    simulatorGuideLoad:
      'Load your matches and choose a match from the table. The simulator then loads the home and away ratings and lineups.',
    simulatorGuidePositions:
      'Set stamina, behaviour arrows and specialties per position. Only active positions affect the simulation.',
    simulatorGuideRatings:
      'You can edit ratings, tactics and positions, or paste ratings directly from the clipboard.',
    simulatorGuideRun:
      'Run the estimate with Simulate Match. Results are averages from 10,000 simulated matches.',
    leagueSimulationLoading: 'Simulating league…',
    leagueSimulationFailed: 'League simulation could not be loaded.',
    leagueTable: 'League table',
    team: 'Team',
    goalsFor: 'Goals for',
    goalsAgainst: 'Goals against',
    goalDifference: 'Goal difference',
    goalDifferenceVsExpected: 'GD-xGD',
    matches: 'Matches',
    round: 'Round',
    home: 'Home',
    away: 'Away',
    result: 'Result',
    simulation: 'Simulation',
    draw: 'Draw',
    goalsHome: 'home goals',
    goalsAway: 'away goals',
    simulateMatch: 'Open match simulator',
    season: 'Season',
    leaguePoints: 'Pts',
    expectedPointsShort: 'xPts',
    goalsForShort: 'GF',
    goalsAgainstShort: 'GA',
    goalDifferenceShort: 'G+/-',
    expectedGoalsForShort: 'xGF',
    expectedGoalsAgainstShort: 'xGA',
    expectedGoalDifferenceShort: 'xG+/-',
    goalDifferenceVsExpectedShort: 'G-xG',
    expectedHomeShort: 'xH',
    expectedDrawShort: 'xD',
    expectedAwayShort: 'xA',
    expectedGoalsHomeShort: 'xGF H',
    expectedGoalsAwayShort: 'xGF A',

    // Team spirit calculator
    teamSpiritCalculator: 'Team spirit impact on midfield',
    teamSpiritCalculatorHelp:
      'Enter midfield values for match days, choose the attitude, and follow team spirit through the updates.',
    startingDate: 'Starting date',
    startingSpirit: 'Starting team spirit',
    matchCount: 'Matches',
    attitude: 'Attitude',
    midfield: 'Midfield',
    spiritBefore: 'Team spirit before match',
    spiritAfter: 'Team spirit after match',
    performanceCoeff: 'Coefficient',
    nextMatchEstimate: 'Match estimate',
    rowType: 'Row',
    matchRow: 'Match',
    updateRow: 'Update',
    resetRow: 'Reset',
    showIntermediateDays: 'Show intermediate days',
    updatesBetweenMatches: 'Updates between matches',
    finalMatch: 'No next match',
    note: 'Note',
    teamSpiritTimelineNote:
      'The default rhythm alternates 3 and 4 updates between matches. The final update can fall on the same day as the next match.',
  },
}

export const getTranslation = (lang, key) => {
  const langObj = translations[lang] || translations.fi
  return langObj[key] || translations.fi[key] || key
}

export const getSupportedLanguages = () => [
  { code: 'fi', name: 'Suomi' },
  { code: 'en', name: 'English' },
]

export default translations
